import { match } from 'ts-pattern'
import z from 'zod'
import { AnalysisStateResponseSchema } from '../../utils/api-client/api-schemas.ts'
import * as styles from './scan-status-badge.css.ts'

export const ScanStatusSchema = z.enum([...AnalysisStateResponseSchema.options, 'unanalyzed', 'stale', 'latest'])
export type ScanStatus = z.infer<typeof ScanStatusSchema>

type ScanStatusBadgeProps = {
  variant: ScanStatus
  style?: React.CSSProperties
}

export const ScanStatusBadge: React.FC<ScanStatusBadgeProps> = ({ variant, ...props }) => {
  if (variant === 'completed' || variant === 'cancelled') {
    return null
  }

  const text = match(variant)
    .with('in-progress', () => 'In progress')
    .with('failed', () => 'Failed')
    .with('queued', () => 'Queued')
    .with('skipped', () => 'Skipped')
    .with('unanalyzed', () => 'Unanalyzed')
    .with('stale', () => 'Stale')
    .with('latest', () => 'Latest')
    .exhaustive()

  return (
    <span className={styles.badge({ variant })} {...props}>
      {text}
    </span>
  )
}
